import {Component, Inject, SecurityContext} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-disclaimer-dialog',
  templateUrl: './disclaimer-dialog.component.html',
  styleUrls: ['./disclaimer-dialog.component.scss']
})
export class DisclaimerDialogComponent {

  public data;
  public data1;
  constructor(@Inject(MAT_DIALOG_DATA) private messageInfo: any, private sanitizer: DomSanitizer) { }

  ngOnInit(){
    if (this.messageInfo.messageType && this.messageInfo.messageType === 'file') {
      this.readFileToString(this.messageInfo.message)
    }
    else {
     this.data = this.messageInfo.message;
    }
  }

  /**
   * Reads file to string
   * @param fileNm 
   */
  private async readFileToString(fileNm) {
    await fetch (fileNm).then(
       res => res.text()).then(
         tempData => {
       this.data = this.sanitizer.sanitize(SecurityContext.HTML,this.sanitizer.bypassSecurityTrustHtml(tempData));
     });  
 
   }

}
